// extracted by mini-css-extract-plugin
export default {"root":"wizard-steps_root__g8COR","step":"wizard-steps_step__2O3zw","active":"wizard-steps_active__KHOOj","completed":"wizard-steps_completed__UPmDP"};